var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6589_1328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 3.99967H14.6668V5.33301H13.3335V13.9997C13.3335 14.1765 13.2633 14.3461 13.1382 14.4711C13.0132 14.5961 12.8436 14.6663 12.6668 14.6663H3.3335C3.15669 14.6663 2.98712 14.5961 2.86209 14.4711C2.73707 14.3461 2.66683 14.1765 2.66683 13.9997V5.33301H1.3335V3.99967H4.66683V1.99967C4.66683 1.82286 4.73707 1.65329 4.86209 1.52827C4.98712 1.40325 5.15669 1.33301 5.3335 1.33301H10.6668C10.8436 1.33301 11.0132 1.40325 11.1382 1.52827C11.2633 1.65329 11.3335 1.82286 11.3335 1.99967V3.99967ZM6.00016 7.33301V11.333H7.3335V7.33301H6.00016ZM8.66683 7.33301V11.333H10.0002V7.33301H8.66683ZM6.00016 2.66634V3.99967H10.0002V2.66634H6.00016Z",
    fill: "#F3787A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6589_1328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f128a058db8aec6661cc989727bc456b.svg";
export { ForwardRef as ReactComponent };